export default {
  deviceOverview: '设备概览',
  historicalData: '历史数据',
  curveAnalysis: '曲线分析',
  statisticalAnalysis: '统计数据',
  faultStatistics: '报警统计',
  unconventionalData: '非常规数据',
  realTime: '实时数据',
  timing: '定时',
  log: '日志',
  indicatingData: '指标数据',
  energyConservation: '节能减排',
  deviceConfig: '设备组态',
  operatingCurve: '24小时运行曲线',
  runTime: '运行时长',
  accumulatedTraffic: '日累计流量',
  powerGeneration: '日累计发电量',
  carbonEmission: '碳排放',
  failureType: '报警类型占比',
  alarmStatistics: '近15天报警统计',
  numberAlarms: '报警次数',
  faultRanking: '故障排名',
  statisticalAnalysis1: '统计分析',
  working: '运行',
  reversal: '反转',
  stop: '停机',
  faultReset: '故障复位'
}
